export default __webpack_public_path__ + "static/media/logo.df7b6ccc.png";